// Display name for team rows. Returns the full team name — abbreviating
// e.g. "Ivory Coast" → "Coast" or "Sydney Swans" → "Swans" hides important
// context (especially for WC countries with multi-word names). The layouts
// rely on CSS `truncate` to handle any overflow gracefully.
export function shortTeamName(fullTeamName) {
  if (!fullTeamName) return "";
  return fullTeamName;
}
